/*! http://mths.be/repeat v0.2.0 by @mathias */
if (!String.prototype.repeat) {
  (function () {
    'use strict'; // needed to support `apply`/`call` with `undefined`/`null`

    var defineProperty = function () {
      // IE 8 only supports `Object.defineProperty` on DOM elements
      try {
        var object = {};
        var $defineProperty = Object.defineProperty;
        var result = $defineProperty(object, object, object) && $defineProperty;
      } catch (error) {}

      return result;
    }();

    var repeat = function repeat(count) {
      if (this == null) {
        throw TypeError();
      }

      var string = String(this); // `ToInteger`

      var n = count ? Number(count) : 0;

      if (n != n) {
        // better `isNaN`
        n = 0;
      } // Account for out-of-bounds indices


      if (n < 0 || n == Infinity) {
        throw RangeError();
      }

      var result = '';

      while (n) {
        if (n % 2 == 1) {
          result += string;
        }

        if (n > 1) {
          string += string;
        }

        n >>= 1;
      }

      return result;
    };

    if (defineProperty) {
      defineProperty(String.prototype, 'repeat', {
        'value': repeat,
        'configurable': true,
        'writable': true
      });
    } else {
      String.prototype.repeat = repeat;
    }
  })();
}